import { AISimulation } from "models/AISimulation"
import { makeRequest } from "./networkUtils"

export const getAISimulations = (filters: any): Promise<AISimulation[]> => {
    return makeRequest("ai-simulations", { params: filters })
}

export const getAISimulation = (id: string): Promise<AISimulation> => {
    return makeRequest(`ai-simulations/${id}`)
}

export const createAISimulationDO = (AISimulation: AISimulation): Promise<AISimulation> => {
    return makeRequest("ai-simulations", { method: "POST", body: AISimulation })
}

export const saveAISimulationDO = (AISimulation: AISimulation): Promise<AISimulation> => {
    return makeRequest(`ai-simulations/${AISimulation.id}`, { method: "PUT", body: AISimulation })
}

export const deleteAISimulationDO = (AISimulation: AISimulation): Promise<void> => {
    return makeRequest(`ai-simulations/${AISimulation.id}`, { method: "DELETE" })
}

export const executeAISimulation = (AISimulation: AISimulation): Promise<void> => {
    return makeRequest(`ai-simulations/${AISimulation.id}/execute`, { method: "POST" })
}